var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"special-component"},[_c('q-spinner-facebook',{attrs:{"size":"45px","color":"primary"}}),_c('div',[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }